import React, { useEffect, useState } from 'react';
import { Input } from 'antd';

const { TextArea } = Input;

interface MultilineTextAreaFieldProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  rows?: number;
  maxLength?: number;
  showCount?: boolean;
  autoSize?: { minRows: number; maxRows: number };
  style?: React.CSSProperties;
  disabled?: boolean;
  readOnly?: boolean;
  [key: string]: any;
}

export const MultilineTextAreaField: React.FC<MultilineTextAreaFieldProps> = ({
  value,
  onChange,
  placeholder,
  rows = 3,
  maxLength,
  showCount = true,
  autoSize,
  style = {},
  disabled = false,
  readOnly = false,
  ...props
}) => {
  const [displayValue, setDisplayValue] = useState<string>('');

  // Convert literal \n to actual newlines for display
  useEffect(() => {
    if (value) {
      // Data is now cleaned at the data provider level, so we just need to handle \n to newlines
      const processedValue = value.replace(/\\n/g, '\n');
      setDisplayValue(processedValue);
    } else {
      setDisplayValue('');
    }
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    setDisplayValue(newValue);

    if (onChange) {
      // Convert actual newlines back to literal \n for storage
      const storageValue = newValue.replace(/\n/g, '\\n');
      onChange(storageValue);
    }
  };

  return (
    <TextArea
      value={displayValue}
      onChange={handleChange}
      placeholder={placeholder}
      rows={rows}
      maxLength={maxLength}
      showCount={showCount}
      autoSize={autoSize}
      disabled={disabled}
      readOnly={readOnly}
      style={{
        whiteSpace: 'pre-wrap',
        fontFamily: 'monospace',
        lineHeight: '1.5',
        ...style,
      }}
      {...props}
    />
  );
};

export default MultilineTextAreaField;
